import { Box, Skeleton, Stack, Typography } from '@mui/material'
import { CompanyCard } from './company-card'
import { useListDeals } from '@/api/accounting-dealer'
import { AppHeader } from '@/components/app-header'

export function HomePage() {
  const { data: deals, isLoading } = useListDeals()

  return (
    <Box width="100%">
      <AppHeader />
      <Typography variant="h2" mb={4} textAlign="center" color="text.secondary">
        Selecione uma empresa
      </Typography>

      <Stack spacing={2}>
        {isLoading ? (
          <Skeleton variant="rounded" height={56} />
        ) : !deals?.length ? (
          <Typography color="textDisabled">
            Não foi possível carregar as empresas. Entre em contato com o
            suporte.
          </Typography>
        ) : (
          deals.map((deal) => <CompanyCard key={deal.key} deal={deal} />)
        )}
      </Stack>
    </Box>
  )
}
